(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offering-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aether-donation-presets')) {
  customElements.define('aether-donation-presets', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-donation-amount]');
        if (!button || !this.contains(button)) return;
        const input = this.closest('form')?.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.donationAmount;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["photo-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('session-photo-demo')) {
  customElements.define('session-photo-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('pageshow', this.onPageShow);
        this.onPageShow();
        return;
      }
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const openButton = this.querySelector('.photo-demo__open');
      const variantSelect = this.querySelector('[data-membership-variant-select]');
      const variantInput = this.querySelector('input[name="id"]');
      const variantPrice = this.querySelector('.pd__price');
      const variantSummary = this.querySelector('[data-membership-variant-summary]');
      const syncVariant = () => {
        if (!variantSelect) return true;
        const option = variantSelect.selectedOptions[0];
        if (!option || option.disabled) {
          openButton.disabled = true;
          return false;
        }
        variantInput.value = option.value;
        variantPrice.textContent = option.dataset.price;
        if (variantSummary) variantSummary.textContent = option.textContent.trim();
        openButton.disabled = false;
        return true;
      };
      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          syncVariant();
          this.clearConsent();
        });
        syncVariant();
      }
      openButton.addEventListener('click', () => {
        if (syncVariant()) dialog.showModal();
      });
      this.querySelector('.photo-demo__close').addEventListener('click', () => dialog.close());
      const inputs = this.querySelectorAll('input[type=file]');
      const panel = this.querySelector('.photo-demo__preview');
      const img = this.querySelector('.photo-demo__preview img');
      const status = this.querySelector('.photo-demo__status');
      const next = this.querySelector('.photo-demo__continue');
      const form = this.querySelector('form');
      const consent = this.querySelector('[data-early-start-consent]');
      const consentTimestamp = this.querySelector('[data-consent-timestamp]');
      const consentStatement = this.querySelector('[data-consent-statement]');
      const consentVersion = this.querySelector('[data-consent-version]');
      const consentLabel = this.querySelector('[data-consent-label]');
      const consentFields = [consentTimestamp, consentStatement, consentVersion];
      let photoLoading = false;
      let photoReady = false;
      let submitting = false;
      const hasConsent = () => consent.checked && !!consentTimestamp.value && consentFields.every(input => !input.disabled);
      const syncButton = () => {
        const option = variantSelect && variantSelect.selectedOptions[0];
        const variantUnavailable = variantSelect && (!option || option.disabled);
        next.disabled = !hasConsent() || photoLoading || submitting || !photoReady || !!variantUnavailable;
      };
      this.clearConsent = () => {
        consent.checked = false;
        consentTimestamp.value = '';
        consentFields.forEach(input => { input.disabled = true; });
        syncButton();
      };
      consent.addEventListener('change', () => {
        if (!consent.checked) {
          this.clearConsent();
          return;
        }
        consentTimestamp.value = new Date().toISOString();
        consentStatement.value = consentLabel.textContent.trim();
        consentFields.forEach(input => { input.disabled = false; });
        syncButton();
      });
      const sync = () => {
        const hasPhoto = [...inputs].some(input => input.files.length);
        if (!hasPhoto) photoReady = false;
        inputs.forEach((input, index) => {input.disabled = false; input.required = !hasPhoto && index === 0;});
        syncButton();
      };
      const reset = (keepInput = null) => {
        this.version = (this.version || 0) + 1;
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
        img.removeAttribute('src');
        panel.hidden = true;
        photoLoading = false;
        photoReady = false;

        inputs.forEach(input => { if (input !== keepInput) input.value = ''; });
        sync();
      };
      this.resetPhoto = reset;
      this.onPageShow = () => {
        submitting = false;
        this.clearConsent();
        syncVariant();
        if ([...inputs].some(input => input.files.length)) sync();
        else reset();
        status.textContent = '';
      };
      window.addEventListener('pageshow', this.onPageShow);
      this.onPageShow();
      form.addEventListener('reset', () => {
        queueMicrotask(() => {
          reset();
          this.onPageShow();
        });
      });
      inputs.forEach(input => input.addEventListener('change', async () => {
        const file = input.files[0];
        if (!file) {reset(); return;}
        reset(input);
        status.textContent = '';
        if (!['image/jpeg','image/png','image/webp'].includes(file.type)) {reset();status.textContent = status.dataset.invalid; return;}
        if (file.size > 10 * 1024 * 1024) {reset();status.textContent = status.dataset.large; return;}
        const version = this.version;
        const url = URL.createObjectURL(file);
        this.objectUrl = url;
        img.src = url;
        photoLoading = true;
        syncButton();
        status.textContent = status.dataset.loading;
        try { await img.decode(); } catch {
          if (version === this.version) { reset(); status.textContent = status.dataset.error; }
          return;
        }
        if (version !== this.version) return;
        this.querySelector('.photo-demo__name').textContent = file.name;
        panel.hidden = false;
        photoLoading = false;
        photoReady = true;
        syncButton();
        status.textContent = status.dataset.ready;
      }));
      this.querySelector('.photo-demo__remove').addEventListener('click', () => {reset();status.textContent = status.dataset.removed;});
      form.addEventListener('submit', (event) => {
        if (submitting) {
          event.preventDefault();
          return;
        }
        if (!syncVariant()) {
          event.preventDefault();
          variantSelect.focus();
          return;
        }
        sync();
        if (!hasConsent()) {
          event.preventDefault();
          this.clearConsent();
          consent.reportValidity();
          consent.focus();
          return;
        }
        if (photoLoading || !photoReady) {
          event.preventDefault();
          status.textContent = photoLoading ? status.dataset.loading : status.dataset.required;
          form.reportValidity();
          return;
        }
        const fields = [...this.querySelectorAll('.photo-demo__fields input')].filter(input => !input.disabled);
        for (const field of fields) {
          if (field.type === 'text' || field.type === 'email') field.value = field.value.trim();
          if (!field.reportValidity()) {event.preventDefault();field.focus();return;}
        }
        if (!form.reportValidity()) {event.preventDefault(); return;}
        inputs.forEach(input => { if (!input.files.length) input.disabled = true; });
        submitting = true;
        syncButton();
        status.textContent = status.dataset.complete;
      });
    }
    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShow);
      if (this.resetPhoto) this.resetPhoto();
      if (this.clearConsent) this.clearConsent();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["support-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aether-help'))customElements.define('aether-help',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.copy=JSON.parse(this.querySelector('[data-ah-copy]').textContent);Object.keys(this.copy).forEach(key=>{const decoder=document.createElement('textarea');decoder.innerHTML=this.copy[key];this.copy[key]=decoder.value});this.path=['topics'];
  this.panel=this.querySelector('dialog');this.heading=this.querySelector('h2');this.intro=this.querySelector('.ah-intro');this.content=this.querySelector('.ah-content');this.launch=this.querySelector('.ah-launch');
  this.launch.addEventListener('click',()=>{this.path=['topics'];this.render();this.panel.showModal();this.launch.setAttribute('aria-expanded','true');this.heading.focus()});
  this.querySelector('.ah-close').addEventListener('click',()=>this.panel.close());
  this.panel.addEventListener('close',()=>{this.launch.setAttribute('aria-expanded','false');this.launch.focus()});
  this.querySelector('[data-back]').addEventListener('click',()=>{if(this.path.length>1)this.path.pop();this.render()});
  this.querySelector('[data-home]').addEventListener('click',()=>{this.path=['topics'];this.render()});
  this.querySelector('.ah-return').addEventListener('click',()=>{const chat=document.querySelector('shopify-chat');if(chat?.close)chat.close();else chat?.removeAttribute('open');this.endHandoff();this.launch.click()});
  document.documentElement.classList.add('ah-ready');this.render();
 }
 go(page){this.path.push(page);this.render()}
 choice(text,action){const button=document.createElement('button');button.type='button';button.className='ah-choice';button.textContent=text;button.addEventListener('click',action);this.content.append(button)}
 link(text,url){const a=document.createElement('a');a.className='ah-choice';a.textContent=text;a.href=url;this.content.append(a)}
 channel(type,label,detail,url,action){
  const icons={telegram:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.9 4.3 18.8 19c-.2 1-.8 1.3-1.7.8l-4.6-3.4-2.2 2.1c-.3.3-.5.5-1 .5l.3-4.7 8.6-7.8c.4-.3-.1-.5-.6-.2L6.9 13 2.3 11.6c-1-.3-1-1 .2-1.5l18-6.9c.8-.3 1.6.2 1.4 1.1z"/></svg>',whatsapp:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.6.5-.1 1.5-.6 1.8-1.2.2-.6.2-1.1.1-1.2l-.4-.3z"/></svg>',email:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm9 7.2L4.2 7H4v.4l8 5.3 8-5.3V7h-.2L12 12.2z"/></svg>',instagram:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7.3a4.7 4.7 0 1 0 0 9.4 4.7 4.7 0 0 0 0-9.4zm0 7.7a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4.9-8.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zM12 4.2c2.5 0 2.8 0 3.8.1 2.6.1 3.8 1.3 3.9 3.9.1 1 .1 1.3.1 3.8s0 2.8-.1 3.8c-.1 2.6-1.3 3.8-3.9 3.9-1 .1-1.3.1-3.8.1s-2.8 0-3.8-.1c-2.6-.1-3.8-1.3-3.9-3.9-.1-1-.1-1.3-.1-3.8s0-2.8.1-3.8C4.4 5.6 5.6 4.4 8.2 4.3c1-.1 1.3-.1 3.8-.1z"/></svg>',form:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm2 4v2h10V7H7zm0 4v2h10v-2H7zm0 4v2h6v-2H7z"/></svg>',inbox:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 1-2z"/></svg>'};
  const el=document.createElement(url?'a':'button');el.className='ah-choice ah-channel ah-channel--'+type;
  if(url){el.href=url;if(/^https?:/.test(url)){el.target='_blank';el.rel='noopener'}}else{el.type='button';el.addEventListener('click',action)}
  const icon=document.createElement('span');icon.className='ah-channel__icon';icon.innerHTML=icons[type]||'';
  const text=document.createElement('span');text.textContent=label;if(detail){const small=document.createElement('small');small.textContent=detail;text.append(small)}
  el.append(icon,text);this.content.append(el);
 }
 render(){
  const c=this.copy,page=this.path.at(-1);this.content.replaceChildren();this.intro.textContent='';
  this.querySelector('[data-back]').textContent='‹ '+c.back;this.querySelector('[data-back]').hidden=this.path.length===1;
  this.querySelector('[data-home]').textContent=c.home;this.querySelector('[data-home]').hidden=page==='topics';
  this.querySelector('.ah-close').setAttribute('aria-label',c.close);this.querySelector('.ah-return').textContent=c.return_help;
  const groups={sessions:[0,1,5,6],work:[7,8,9,10,11],membership:[2,11],orders:[3,4]};
  if(page==='topics'){
   this.heading.textContent=c.title;this.intro.textContent=c.intro;Object.keys(groups).forEach(topic=>this.choice(c[topic],()=>this.go(topic)));this.choice(c.contact,()=>this.go('contact'));
  }else if(groups[page]){
   this.heading.textContent=c[page];this.intro.textContent=c.questions;groups[page].forEach(i=>this.choice(c['q'+i],()=>this.go('answer:'+i)));
  }else if(page.startsWith('answer:')){
   const i=Number(page.split(':')[1]);this.heading.textContent=c['q'+i];const p=document.createElement('p');p.className='ah-answer';p.textContent=c['a'+i];this.content.append(p);
   if(i===2||i===11)this.link(c.membership,'/products/aetherservants-family-membership');
   if(i===5)this.link(c.guide,'/pages/which-service');
   if(i===7||i===8||i===9)this.link(c.cleansing,'/products/negative-energy-removal');
   this.choice(c.contact,()=>this.go('contact'));
  }else{
   const d=this.dataset;this.heading.textContent=c.contact;this.intro.textContent=c.contact_note;
   if(d.telegram)this.channel('telegram',c.telegram,'',d.telegram);
   if(d.whatsapp)this.channel('whatsapp',c.whatsapp,'',d.whatsapp);
   if(d.email)this.channel('email',c.email,d.email,'mailto:'+d.email);
   if(document.querySelector('shopify-chat'))this.channel('inbox',c.inbox,'',null,()=>this.handoff());
   this.channel('form',c.form,'','/pages/contact');
   if(d.instagram)this.channel('instagram','Instagram','',d.instagram);
  }
  this.panel.scrollTop=0;if(this.panel.open)this.heading.focus();
 }
 async handoff(){
  const chat=document.querySelector('shopify-chat');if(!chat){location.href='/pages/contact';return}
  this.panel.close();document.documentElement.classList.add('ah-inbox');this.querySelector('.ah-return').hidden=false;
  if(typeof chat.show==='function')chat.show();else chat.setAttribute('open','');
  this.observer?.disconnect();this.observer=new MutationObserver(()=>{if(!chat.hasAttribute('open'))this.endHandoff()});this.observer.observe(chat,{attributes:true,attributeFilter:['open']});
 }
 endHandoff(){this.observer?.disconnect();document.documentElement.classList.remove('ah-inbox');this.querySelector('.ah-return').hidden=true}
 disconnectedCallback(){this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
